import {
    getInitialData, setContainerHeader, scwFetch, resetContainers,
    clearDynamicContainer, toggleSidePanel, toggleDynamicContainerMode, dynamicContainer
} from '../main';
import {broadcastSsoStateChange} from "../utils/broadcast";
import {onSubmit} from "../utils/form";

interface ForgotPasswordState {
    state: string;
    environmentReadableName: string;
    loginString: string;
}

interface ForgotPasswordResponse {
    isMailSent?: boolean;
    requestedRedirectUrl?: string;
    mainUrl?: string;
}

const state = getInitialData<ForgotPasswordState>();

const templates = {
    forgotPasswordForm: document.querySelector<HTMLTemplateElement>("template#template_forgotPasswordForm"),
    forgotPasswordSent: document.querySelector<HTMLTemplateElement>("template#template_forgotPasswordSent"),
};

const redirectToLogin = () => {
    const backUrl = new URL('/view/auth/login/' + state.state, window.location.origin)
    backUrl.searchParams.set("login_challenge", localStorage.getItem("login_challenge") ?? '');
    
    window.location.replace(backUrl);
};

setContainerHeader({
    title: 'Forgot Your Password?',
    subTitle: "Enter your email or username and company name, we'll send you a mail to reset your password",
    backButtonAction: redirectToLogin
});

const formFragment = templates.forgotPasswordForm?.content?.cloneNode(true) as DocumentFragment;
const submitButton = formFragment.querySelector('button[form=forgotPasswordForm]') as HTMLButtonElement;
submitButton.innerHTML = 'Send Request' + (state.environmentReadableName ? ` (${state.environmentReadableName})` : '');

const form = formFragment.querySelector('form#forgotPasswordForm') as HTMLFormElement;
const notificationContainer = formFragment.querySelector('div.scw-toast-container[data-toast-notification-container]') as HTMLDivElement;

if (state.loginString) {
    const loginStringInput = form.querySelector('input#login_string') as HTMLInputElement;

    if (loginStringInput) {
        loginStringInput.value = state.loginString
        loginStringInput.disabled = true
    }
}

const backToLoginButton = formFragment.querySelector('button[data-back-to-login="true"]') as HTMLButtonElement;
backToLoginButton.addEventListener('click', async () => {
    redirectToLogin()
});

onSubmit(form, async (formData) => {
    if (state.loginString) {
        formData.set("login_string", state.loginString);
    }

    const response = await scwFetch<ForgotPasswordResponse>("/api/forgot-password/" + state.state, {
        method: "POST",
        body: Object.fromEntries(formData),
        notificationContainer
    },);

    if (response && response.isMailSent) {
        resetContainers();
        clearDynamicContainer();
        toggleSidePanel(true);
        toggleDynamicContainerMode(true);

        const forgotPasswordSentFragment = templates.forgotPasswordSent?.content?.cloneNode(true) as DocumentFragment;
        const redirectButton = forgotPasswordSentFragment.querySelector('button') as HTMLButtonElement;

        redirectButton.addEventListener("click", async () => {
          const redirectUrl = response.requestedRedirectUrl || response.mainUrl;

          if (redirectUrl?.length) {
            broadcastSsoStateChange({
              action: "SSO_REDIRECT_TO_TOOL",
              payload: { url: redirectUrl },
            });
            window.location.replace(redirectUrl);
          }
        });

        dynamicContainer.append(forgotPasswordSentFragment);
    }
}, submitButton);

dynamicContainer.append(formFragment);